"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
/** Visible SSR content; opacity enhancement never moves document content. */
export function EditorialMotion() {
  const pathname = usePathname();
  useEffect(() => {
    const media = matchMedia("(prefers-reduced-motion: reduce)");
    let dispose = () => {};
    function setup() {
      dispose();
      if (media.matches || !("IntersectionObserver" in window)) return;
      const animations = new Set<Animation>();
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            observer.unobserve(entry.target);
            const animation = entry.target.animate(
              [{ opacity: 0.72 }, { opacity: 1 }],
              {
                duration: 480,
                easing: "cubic-bezier(.2,.7,.2,1)",
              },
            );
            animations.add(animation);
            animation.onfinish = () => animations.delete(animation);
            // A single opacity pass through the diagram indicates flow without
            // moving cards or running an animation loop while the reader rests.
            entry.target
              .querySelectorAll(".ex-layer-connector")
              .forEach((node, index) => {
                const pulse = node.animate(
                  [{ opacity: 0.25 }, { opacity: 1 }],
                  {
                    duration: 700,
                    delay: index * 180,
                    easing: "ease-out",
                  },
                );
                animations.add(pulse);
                pulse.onfinish = () => animations.delete(pulse);
              });
          }
        },
        { threshold: 0.12 },
      );
      document
        .querySelectorAll(
          ".ec-site [data-editorial-reveal], .ec-site .ec-section > .ec-container > .ec-section-head, .ec-site .ec-workload-diagram",
        )
        .forEach((node) => observer.observe(node));
      dispose = () => {
        observer.disconnect();
        animations.forEach((a) => a.cancel());
      };
    }
    setup();
    media.addEventListener("change", setup);
    return () => {
      dispose();
      media.removeEventListener("change", setup);
    };
  }, [pathname]);
  return null;
}
